addEventListener('DOMContentLoaded', _ => {
    [...document.querySelectorAll('img.video-component-cover')].forEach(cover => {
        cover.nextElementSibling.firstElementChild.addEventListener('click', _ => {
            cover.parentElement.innerHTML = createIFrame(cover.dataset.url, cover.dataset.title)
        })
    })
})

const createIFrame = (url, title) => {
    return `<iframe class="embed-responsive-item" src="${url}"
                    title="${title}"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>`
}
